/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RecordSource {
  ZOOM = 'zoom',
  GOOGLE_MEET = 'google_meet',
  TEAMS_MEET = 'teams_meet',
  PHONE_CALL = 'phone_call',
  VOICE_RECORDER = 'voice_recorder',
  SCREEN_RECORDER = 'screen_recorder',
  MANUAL_UPLOAD = 'manual_upload',
}
